(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var selector = '.load-more .button, button[id^="load-more-btn-"]';
  var observed = new WeakSet();
  var pending = new WeakSet();
  var observer;

  function isAvailable(button) {
    if (!button || !document.contains(button)) return false;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
    if (button.getAttribute('aria-busy') === 'true') return false;
    return button.getClientRects().length > 0;
  }

  function isNearViewport(button) {
    var rect = button.getBoundingClientRect();
    return rect.top <= window.innerHeight + 600 && rect.bottom >= -600;
  }

  function load(button) {
    if (!isAvailable(button) || pending.has(button)) return;

    pending.add(button);
    button.click();

    // The native loader may replace its button; custom loaders keep theirs.
    // Recheck the latter while they remain in the preload area so short pages
    // continue filling without requiring extra scrolling.
    window.setTimeout(function () {
      pending.delete(button);
      if (isAvailable(button) && isNearViewport(button)) load(button);
    }, 1200);
  }

  function observe(button) {
    if (!button || observed.has(button)) return;
    observed.add(button);
    observer.observe(button);
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(selector)) observe(root);
    root.querySelectorAll(selector).forEach(observe);
  }

  function init() {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) load(entry.target);
      });
    }, {
      root: null,
      rootMargin: '600px 0px',
      threshold: 0,
    });

    scan(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
